import { render, staticRenderFns } from "./SettingsCardNew.vue?vue&type=template&id=26d53e88"
import script from "./SettingsCardNew.vue?vue&type=script&lang=ts"
export * from "./SettingsCardNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports